import React from "react";
import {FlyerPageDto} from "../../../../../dtos";

type Props = {
    value: number;
    currentPage: FlyerPageDto;
}

export const OptionsForSelectPages = (props: Props) => {
    const {value, currentPage} = props;
    const numberOfPage = currentPage.flpPageNo || -1;
    if(numberOfPage === -1 || value === -1){
        return (
            <></>
        )
    }
    // const selectedPageNo = selectedPages?.map((key => key?.flpPageNo));
    const isDisabled = numberOfPage === value || numberOfPage + 1 === value;
    return (
        <option value={value} disabled={isDisabled}>
            {value}
        </option>
    )
}